import React, { useEffect, useState } from "react";
import Auth from "src/auth";

import { apiCallResponse } from "src/_apiConfig/apiCall";
import { FilterContainsInsensitive } from "../common/FilterCondition";
import {
  CommonSearchExtra,
  SCAddButton,
  SCInput,
  updateSearchStatus,
} from "../common/CommonSearch";
import { TableHeader } from "../common/Table/TableHeaderLabel";
import CommonList from "../common/CommonList";

const CircleList = () => {
  const { authenticated } = Auth();
  const [usersData, setuserData] = useState([]); // List data manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage;
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage;
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  // eslint-disable-next-line no-unused-vars
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [textField, settextField] = useState("name"); // table header Default Selected Column
  const [order, setorder] = useState("asc"); // table header Default Selected Column order Set
  const [orderClick, setOrderClick] = useState(true); // table header orderClick Column manage

  // Your default search model
  const SearchFilterModel = {
    name: "",
    desc: "",
  };

  const [search, setSearch] = useState(SearchFilterModel);

  useEffect(() => {
    setloading(true);
    resetPageLimit(0);
    getPageCount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getCircleList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, textField, orderClick]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getCircleList();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  const resetPageLimit = (pageLimit) => {
    setpageLimit(pageLimit || 0);
  };
  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Manage
  const paggingDisabledManage = (totalRecord) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // Filter paramater Value manage for API
  const filterManage = () => {
    let filter = "";
    filter = "&$filter=";

    filter = FilterContainsInsensitive(filter, "name", search.name);
    filter = FilterContainsInsensitive(filter, "desc", search.desc);

    if (filter === "&$filter=") {
      filter = "";
    }

    return filter;
  };
  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(`Circle_Master?${filterManage()}`).then((res) => {
        if (res.success) paggingDisabledManage(parseInt(res.data.length) || 0);
      });
    }
  };

  const getCircleList = async () => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      await apiCallResponse(
        `Circle_Master?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
          itemPerPage
        )}${filterManage()}`
      ).then((res) => {
        if (res.success) {
          setuserData(res.data);
          if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
            paggingDisabledManage(pageCount);
          }
        }
        setloading(false);
      });
    }
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsSearch(true);
  };
  // Clear Button Click Event
  const clearSearchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setuserData();
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };

  const searchControl = (
    <>
      <SCInput
        label="Name:"
        name={"name"}
        value={search.name}
        onChange={updateSearch}
      />
      <SCInput
        label="Description:"
        name={"desc"}
        value={search.desc}
        onChange={updateSearch}
      />
    </>
  );
  let additional = (
    <CommonSearchExtra
      isDisabledSearchClear={loading}
      extraControl={searchControl}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearchButton={clearSearchButton}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      extraSearchControl={<SCAddButton tourl={"/addcircle"} />}
    />
  );
  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    if (textField !== getTextField) {
      setorder("asc");
    } else {
      !orderClick ? setorder("asc") : setorder("desc");
    }
    resetPageLimit(0);
    settextField(getTextField);
  };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };

  const fields = [
    {
      key: "name",
      _style: { width: "40%" },
      label: TableHeaderSet("Name", "name"),
    },
    {
      key: "desc",
      _style: { width: "40%" },
      label: TableHeaderSet("Discription", "desc"),
    },
    {
      key: "EditionInRow",
      _style: { width: "20%" },
      label: TableHeaderSet("Status", "status"),
    },

    {
      key: "show_details",
      label: "Edit",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
  ];
  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="Circle List"
      loading={loading}
      additional={additional}
      tabBtn="Edit"
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      path="/editcircle/"
      id="circleId"
    />
  );
};
export default CircleList;
